import { Link } from "@tanstack/react-router";
import { Card, CardContent, CardFooter } from "../../@/components/ui/card";
import { Button } from "../../@/components/ui/button";
import { FaStar } from "react-icons/fa";
import { ClipLoader } from "react-spinners";
import { ArrowRight } from "lucide-react";
// import "react-circular-progressbar/dist/styles.css";
import { useState } from "react";
import { getStudentAppBaseUrlForCurrentHost } from "@/lib/studentAppUrl";

export function CourseCard({ course, tab, showAdminAllActions = false }) {
  if (!course) return null;
  const [isLoading, setIsLoading] = useState(false);

  const manageCourseIdentifier =
    course.slug?.toString?.() ??
    (course.slug ? String(course.slug) : null) ??
    course.id?.toString?.() ??
    String(course.id);

  const totalReviews = Number(course.total_reviews ?? 0) || 0;
  const avgRating = Number(course.average_rating ?? 0) || 0;
  const displayRating = totalReviews > 0 ? Math.ceil(avgRating) : 0;
  const priceNumber = Number(course.price ?? 0) || 0;
  const displayPrice = priceNumber === 0 ? "Free" : `KES ${priceNumber.toLocaleString()}`;

  const handleButtonClick = () => {
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1000);
  };

  const previewCourse = () => {
    const baseUrl = getStudentAppBaseUrlForCurrentHost();
    window.open(`${baseUrl}/course/${course.slug}`, "_blank", "noopener,noreferrer");
  };

  return (
    <Card className="overflow-hidden gap-2 pt-0 mb-2 w-full p-2 min-w-50 max-w-full rounded-md h-auto">
      <div className="w-full h-40 px-3 pt-3 pb-2 bg-(--neutral-100) rounded-md flex items-center justify-center overflow-hidden">
        <img
          src={
            course.thumbnail ||
            "https://lms-internal.zinduaschool.com/assets/thumbnails/default-course/default-thumbnail.png"
          }
          alt={course.title}
          className="w-auto h-full max-w-full object-cover rounded-md"
        />
      </div>
      <CardContent className="flex-1 px-3 pt-1 pb-0 space-y-1">
        <h4 className="text-base font-semibold font-heading leading-snug truncate text-(--neutral-950)">
          {course.title}
        </h4>
        <div className="text-base line-clamp-2 font-body text-(--neutral-800)">
          {typeof course.summary === "string" ? course.summary : ""}
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-base font-semibold font-body text-(--neutral-950)">
            {displayPrice}
          </span>
          <div className="flex items-center space-x-1">
            <FaStar className="text-(--color-gold) text-sm" />
            <span className="text-sm font-body text-(--neutral-700)">
              {displayRating} ({totalReviews} reviews)
            </span>
          </div>
        </div>
      </CardContent>
      <CardFooter className="flex px-3 pt-1 pb-2">
        {showAdminAllActions ? (
          <div className="flex-1 w-full gap-2 justify-center">
            <Link
              to="/manage-course/$courseId"
              params={{ courseId: manageCourseIdentifier }}
              state={{ course }}
              className="w-full"
            >
              <Button
                variant=""
                className={`w-full mb-2 ${isLoading ? "cursor-not-allowed" : ""}`}
                onClick={handleButtonClick}
                disabled={isLoading}
              >
                {isLoading ? (
                  <ClipLoader size={20} color="var(--color-primary)" />
                ) : (
                  <>
                    Manage Course
                    <ArrowRight />
                  </>
                )}
              </Button>
            </Link>

            <Button variant="outline" className="w-full" onClick={previewCourse}>
              Preview Course
              <ArrowRight />
            </Button>
          </div>
        ) : tab === "my" || tab === "managed" ? (
          <Link
            to="/manage-course/$courseId"
            params={{ courseId: manageCourseIdentifier }}
            state={{ course }}
            className="w-full"
          >
            <Button
              variant="outline"
              className={`w-full ${isLoading ? "cursor-not-allowed" : ""}`}
              onClick={handleButtonClick}
              disabled={isLoading}
            >
              {isLoading ? (
                <ClipLoader size={20} color="var(--color-primary)" />
              ) : (
                <>
                  Manage Course
                  <ArrowRight />
                </>
              )}
            </Button>
          </Link>
        ) : (
          <Button variant="outline" className="w-full" onClick={previewCourse}>
            Preview Course
            <ArrowRight />
          </Button>
        )}
      </CardFooter>
    </Card>
  );
}
